export const zuoshanList = [
  '壬山丙',
  '壬山丙兼亥',
  '壬山丙兼子',
  '子山午',
  '子山午兼壬',
  '子山午兼癸',
  '癸山丁',
  '癸山丁兼子',
  '癸山丁兼丑',
  '丑山未',
  '丑山未兼癸',
  '丑山未兼艮',
  '艮山坤',
  '艮山坤兼丑',
  '艮山坤兼寅',
  '寅山申',
  '寅山申兼艮',
  '寅山申兼甲',
  '甲山庚',
  '甲山庚兼寅',
  '甲山兼卯',
  '卯山酉',
  '卯山酉兼甲',
  '卯山酉兼乙',
  '乙山辛',
  '乙山辛兼卯',
  '乙山辛兼辰',
  '辰山戌',
  '辰山戌兼乙',
  '辰山戌兼巽',
  '巽山乾',
  '巽山乾兼辰',
  '巽山乾兼巳',
  '巳山亥',
  '巳山亥兼巽',
  '巳山亥兼丙',
  '丙山壬',
  '丙山壬兼巳',
  '丙山壬兼午',
  '午山子',
  '午山子兼丙',
  '午山子兼丁',
  '丁山癸',
  '丁山癸兼午',
  '丁山癸兼未',
  '未山丑',
  '未山丑兼丁',
  '未山丑兼坤',
  '坤山艮',
  '坤山艮兼未',
  '坤山艮兼申',
  '申山寅',
  '申山寅兼坤',
  '申山寅兼庚',
  '庚山甲',
  '庚山甲兼申',
  '庚山甲兼酉',
  '酉山卯',
  '酉山卯兼庚',
  '酉山卯兼辛',
  '辛山乙',
  '辛山乙兼酉',
  '辛山乙兼戌',
  '戌山辰',
  '戌山辰兼辛',
  '戌山辰兼乾',
  '乾山巽',
  '乾山巽兼戌',
  '乾山巽兼亥',
  '亥山巳',
  '亥山巳兼乾',
  '亥山巳兼壬'
]
